import { createAction } from 'redux-actions';

export const getInvestmentSymbols = createAction('GET_INVESTMENT_SYMBOL_LOOKUP', (payload) => payload, (payload, meta) => meta);
export const getInvestmentSymbolsSuccess = createAction('GET_INVESTMENT_SYMBOL_LOOKUP_SUCCESS');
export const getInvestmentSymbolsFailure = createAction('GET_INVESTMENT_SYMBOL_LOOKUP_FAILURE');
